module.exports = __webpack_public_path__ + "img/more_equal.6e05bcb3.svg";